import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { getAccountType, isTrialActive } from '../../../redux/helper';
import { isBillingTypeInvoice } from '../../../redux/modules/user/action';
import Modal from '../../Common/Modal/Modal';
import { AccountTypes } from '../subscriptionTypes';

const STORAGE_KEY = 'invoice_billing_deprecated_hidden';

function isHidden() {
    const clickedAt = localStorage.getItem(STORAGE_KEY);
    if (!clickedAt) {
        return false;
    }
    return moment(clickedAt)
        .add(1, 'd')
        .isAfter(moment());
}

class InvoiceBillingDeprecatedWarningModal extends Component {

    constructor(props) {
        super(props);

        this.loadingGotCancelled = false;
        this.state = {
            isInvoice: false,
            isHidden: isHidden()
        };

        this.hideModal = this.hideModal.bind(this);
        this.hideModalAndGoToDetails = this.hideModalAndGoToDetails.bind(this);
    }

    componentDidMount() {
        this.props.actions.isBillingTypeInvoice()
            .then((isInvoice) => {

                if (this.loadingGotCancelled) {
                    return;
                }

                this.setState({
                    isInvoice
                });
            });
    }

    componentWillUnmount() {
        this.loadingGotCancelled = true;
    }

    hideModal(then) {
        this.setState({
            isHidden: true
        }, () => {
            localStorage.setItem(STORAGE_KEY, moment()
                .format());
            if (typeof then === 'function') {
                then();
            }
        });
    }

    hideModalAndGoToDetails() {
        this.hideModal(() => {
            this.props.history.push('/account/subscription/edit/billingdetails');
        });
    }

    render() {

        const { isHidden, isInvoice } = this.state;
        const { accountType, trialActive } = this.props;

        if (isHidden || !isInvoice || trialActive || accountType === AccountTypes.light) {
            return null;
        }

        return (
            <Modal
                id="modal-invoice-billing-deprecated"
                title="Zahlungsart “Rechnung”"
                type="confirmation"
                footer={
                    <div className="btn-group">
                        <a
                            className="btn modal-link-btn"
                            onClick={this.hideModal}
                        >
                            Später anpassen
                        </a>
                        <a
                            className="btn btn--forward-action btn--save btn--primary-green"
                            onClick={this.hideModalAndGoToDetails}
                        >
                            Jetzt anpassen
                        </a>
                    </div>
                }
            >
                <p>
                    Sie nutzen derzeit die Zahlungsart “Rechnung”.
                    Leider können wir Ihnen diese Zahlungsmöglichkeit in Zukunft nicht mehr
                    anbieten.
                </p>
                <p>
                    Ab sofort stehen Ihnen als Zahlungsmöglichkeiten das SEPA-Lastschriftmandat und
                    die Zahlung per Kreditkarte zur Verfügung. <br />
                    Bitte ändern Sie Ihre Zahlungsdetails bis zum 31. März 2019, um auch weiterhin
                    alle Vorteile von Scaffeye nutzen zu können.
                </p>
            </Modal>
        );
    }

}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        isBillingTypeInvoice
    }, dispatch)
});

const mapStateToProps = (state) => {
    const trialActive = isTrialActive(state);
    const accountType = getAccountType(state);
    return {
        accountType,
        trialActive
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoiceBillingDeprecatedWarningModal));
